import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";

@staticImplements<ResponseModelInterfaceStatic>()
export class Point
{
    public constructor(
        public time: Date,
        public value: number,
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): Point
    {
        return new this(
            elem.firstChildByTag("time").valueAsDate(),
            elem.firstChildByTag("value").valueAsNumber(),
        );
    }
}
